import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@origo/origo-ui';
import styles from './FormFooterActions.module.css';

interface FormFooterActionsProps {
    onCancel: () => void;
    onSave: () => void;
    /** Valgfri destruktiv handling — legges til venstre, adskilt fra Forkast/Lagre. */
    onDelete?: () => void;
    deleteLabel?: string;
    saveDisabled?: boolean;
    isSaving?: boolean;
    /** Skiller knapperaden visuelt fra form-innholdet — 'bottom' legger
     *  border-top, 'top' legger border-bottom. Default 'bottom'. */
    placement?: 'top' | 'bottom';
}

const FormFooterActions: React.FC<FormFooterActionsProps> = ({
    onCancel,
    onSave,
    onDelete,
    deleteLabel,
    saveDisabled = false,
    isSaving = false,
    placement = 'bottom',
}) => {
    const { t } = useTranslation();
    const placementClass = placement === 'top' ? styles.placementTop : styles.placementBottom;

    return (
        <div className={`${styles.footer} ${placementClass}`} role="group" aria-label={t('common.actions')}>
            {onDelete && (
                <Button variant="danger" onClick={onDelete} disabled={isSaving} className={styles.deleteAction}>
                    {deleteLabel ?? t('common.delete')}
                </Button>
            )}
            <Button variant="secondary" onClick={onCancel} disabled={isSaving}>
                {t('common.discard')}
            </Button>
            <Button variant="primary" onClick={onSave} disabled={saveDisabled || isSaving}>
                {t('common.save')}
            </Button>
        </div>
    );
};

export default FormFooterActions;
